<template>
    <div class="card card-body mb-3">
        <div class="d-flex justify-content-between">
            <a :href="this.baseUrl + 'api/unduhhasiluji?usulan_id=' + this.id" class="btn bg-gradient-success text-nowrap mb-0 me-3" target="_blank">Unduh Form</a>
            <input type="file" class="form-control" ref="data.file_form" @change="handleUploadForm">
            <a :href="this.baseUrl + 'storage/hasil_uji/' + this.data.unggah_hasil" class="btn bg-gradient-warning text-nowrap ms-3 mb-0" v-if="this.data.unggah_hasil" target="_blank">Lihat Hasil Upload</a>
            <button type="button" class="btn bg-gradient-info text-nowrap mb-0 ms-3" @click="storeForm">Unggah Form</button>
        </div>
    </div>
    <div class="card card-body mb-3">
        <div class="d-flex justify-content-between">
            <a :href="this.baseUrl + 'api/unduhlhu?usulan_id=' + this.id" class="btn bg-gradient-success text-nowrap mb-0 me-3" target="_blank">Unduh Form LHU</a>
            <input type="file" class="form-control" ref="data.file_lhu" @change="handleUploadLhu">
            <a :href="this.baseUrl + 'storage/hasil_uji/' + this.data.unggah_lhu" class="btn bg-gradient-warning text-nowrap ms-3 mb-0" v-if="this.data.unggah_lhu" target="_blank">Lihat Hasil Upload</a>
            <button type="button" class="btn bg-gradient-info text-nowrap mb-0 ms-3" @click="storeLhu">Unggah Form LHU</button>
        </div>
    </div>
    <div class="d-flex justify-content-end">
        <button @click="store" class="btn bg-gradient-primary">Selesaikan Proses</button>
    </div>
</template>

<script>
export default {
    'nama': 'Upload Analisis',
    data() {
        return {
            id: this.$route.params.id,
            data: {
                status: 'Selesai Unggah Usulan',
            },
            baseUrl: process.env.VUE_APP_URL,
        }
    },
    methods: {
        handleUploadForm(event) {
            this.data.file_form = event.target.files[0];
        },
        handleUploadLhu(event) {
            this.data.file_lhu = event.target.files[0];
        },
        storeForm() {
            this.axios.post('unggah-hasil/' + this.id, { hasil_uji: this.data.file_form }, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                if (response.data.error) {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'File Tidak Valid'
                    });
                } else {
                    this.$swal.fire({
                        icon: 'success',
                        title: response.data.message
                    }).then(() => {
                        event.target.value = '';
                        this.data.unggah_hasil = response.data.data.unggah_hasil;
                    });
                }
            }).catch(() => {
                this.$swal.fire({
                    icon: 'error',
                    title: 'File Tidak Valid'
                })
            });
        },
        storeLhu() {
            this.axios.post('unggah-lhu/' + this.id, { lhu: this.data.file_lhu }, { headers: { 'Content-Type': 'multipart/form-data' } }).then((response) => {
                if (response.data.error) {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'File Tidak Valid'
                    });
                } else {
                    this.$swal.fire({
                        icon: 'success',
                        title: response.data.message
                    }).then(() => {
                        event.target.value = '';
                        this.data.unggah_lhu = response.data.data.unggah_lhu;
                    });
                }
            }).catch(() => {
                this.$swal.fire({
                    icon: 'error',
                    title: 'File Tidak Valid'
                })
            });
        },
        store() {
            this.axios.put('usulan/' + this.id, this.data).then((response) => {
                this.$swal.fire({ icon: 'success', title: response.data.message }).then(() => {
                    this.$router.push({ name: 'ujilab.pengujian' });
                });
            });
        }
    },
    mounted() {
        this.axios.get('usulan/' + this.id).then((response) => {
            this.data.jumlah = response.data.data.jumlah;
            this.data.kategori_id = response.data.data.kategori_id;
            this.data.subkategori_id = response.data.data.subkategori_id;
            this.data.unggah_hasil = response.data.data.unggah_hasil;
            this.data.unggah_lhu = response.data.data.unggah_lhu;
        });
    }
}
</script>